
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources02On as ObiSources02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-02-on.js';
 
 
 

 
 export const ObiSources02On = createComponent({
   react: React,
   tagName: 'obi-sources-02-on',
   elementClass: ObiSources02OnElement,
   events: {
     
   }
  });
 
 